import React, { useEffect, useState } from 'react';
import Amplify from 'aws-amplify';
import { Switch, Route } from 'react-router-dom';
import awsmobile from '@sdk/aws-exports';
import '@aws-amplify/storage';
import '@aws-amplify/api';
import '@aws-amplify/cache';
import { useHistory } from 'react-router';
import ic_scroll from '@images/up-arrow.svg';

import { Transition } from '@headlessui/react';
// Individual Components
import AccountRouter from '@components/pages/Account';
import PollRouter from '@components/pages/Poll';
import PollDetailPage from '@components/pages/Poll/PollDetailPage';
import PollCreatePage from '@components/pages/Poll/New';
import SignupPage from '@components/pages/Signup';
import LoginPage from '@components/pages/Login';
import VerifyPage from '@components/pages/Verify';
import FeedRouter from '@components/pages/Feed';
import NewPage from '../pages/Feed/NewPage';
import RecentPage from '@components/pages/Recent';
import ResetPasswordPage from '@components/pages/ResetPassword';
import AlertsPage from '@components/pages/Alerts';
import ActionPage from '@components/pages/Action';
import AdminRouter from '@components/pages/admin';
import ProfileSetupPage from '@components/pages/Account/Setup';
import CompanyRouter from '@components/pages/Company';
import IdeaRouter from '@components/pages/Idea';
// End of Insdividual Components

import BottomAppBar, {
  BottomAppBarItem,
} from '@components/modules/BottomAppBar';
import WebNavbar from '@components/modules/WebNavbar';
import { Navbar } from '@components/modules/Navbar';

import AccountIcon from '@images/bottomNav/individual/Account.png';
import NotificationIcon from '@images/bottomNav/individual/Notification.png';
import RecentIcon from '@images/bottomNav/individual/Recent.png';
import FeedsIcon from '@images/bottomNav/individual/Feeds.png';
import NewIcon from '@images/scroll.png';

import ScrollToTop from '@utils/ScrollToTop';
import PrivateRoute from './PrivateRoute';
import { useAuth } from '@hooks/Auth';
import PopupModule from '@components/modules/Popup';
import useTheme from '@theme/useTheme';
import { MyGlobalContext } from '@context/customContext';
import {
  getCompanyThemesByCompanyID,
  getGuestData,
} from '@sdk/managers/UsersManager';
import defaultTheme from '@theme/defaultTheme';
import { syncVoteData } from '@sdk/managers/VotesManager';

Amplify.configure(awsmobile);
// Auth.configure({
//     userPoolId: awsmobile["aws_user_pools_id"],
//     userPoolWebClientId: awsmobile["aws_user_pools_web_client_id"],
//     region: awsmobile["aws_cognito_region"],
//     identityPoolId: awsmobile["aws_cognito_identity_pool_id"],
//     mandatorySignIn: false,
//     authenticationFlowType: "USER_PASSWORD_AUTH",
// });s

// try to deploy

const routes = [
  {
    path: '/home',
    main: NewPage,
    enableGuest: true,
  },
  {
    path: '/feed',
    main: FeedRouter,
  },
  {
    path: '/recent',
    exact: true,
    main: RecentPage,
  },
  {
    path: '/alerts',
    exact: true,
    main: AlertsPage,
  },
  {
    path: '/action',
    exact: true,
    main: ActionPage,
  },
  {
    path: '/account',
    main: AccountRouter,
  },
  {
    path: '/company',
    main: CompanyRouter,
  },
  {
    path: '/idealist',
    main: IdeaRouter,

    // enableGuest: true
  },
  {
    path: '/idea',
    main: IdeaRouter,
    enableGuest: true,
  },
  {
    path: '/poll',
    main: PollRouter,
    enableGuest: true,
  },
  {
    path: '/admin',
    main: AdminRouter,
    admin: true,
  },
  {
    path: '/signup',
    main: SignupPage,
    public: true,
  },
  {
    path: '/profile/setup',
    main: ProfileSetupPage,
    public: false,
    hideBottomBar: false,
  },
  {
    path: '/login',
    main: LoginPage,
    public: true,
  },
  {
    path: '/verify',
    main: VerifyPage,
    public: true,
  },
  {
    path: '/reset-password',
    main: ResetPasswordPage,
    public: true,
  },
];

const BOTTOM_APPBAR_ITEMS: BottomAppBarItem[] = [
  {
    label: 'Feeds',
    value: 'feeds',
    icon: <img src={FeedsIcon} alt="feeds" />,
    path: '/feed',
  },
  {
    label: 'Tertiary Projects',
    value: 'idea',
    icon: <img src={NewIcon} alt="edu" style={{ filter: 'grayscale(100%)' }} />,
    path: '/idealist',
  },
  {
    label: 'Recent',
    value: 'recent',
    icon: <img src={RecentIcon} alt="recent" />,
    path: '/recent',
  },
  {
    label: 'Alerts',
    value: 'notifications',
    icon: <img src={NotificationIcon} alt="notifications" />,
    path: '/alerts',
  },
  {
    label: 'Account',
    value: 'account',
    icon: <img src={AccountIcon} alt="account" />,
    path: '/account',
  },
];

const BlankPage = () => {
  const history = useHistory();
  React.useEffect(() => {
    history.push('/home');
  }, []);
  return <div></div>;
};

const App: React.FC = () => {
  const { user, loading, dbUser, company } = useAuth();
  const { theme, loaded } = useTheme();
  const [themeData, setThemeData] = useState(defaultTheme);
  const [customTheme, setCustomTheme] = useState<any>({});
  const [guest, setGuest] = useState<string>('');
  const history = useHistory();

  useEffect(() => {
    async function getTheme(companyData) {
      try {
        if (!dbUser || !company) return;
        if (companyData) {
          const companyThemeRes = await getCompanyThemesByCompanyID(
            companyData.companyID
          );
          const customTheme = companyThemeRes?.data?.result?.items[0] || {};

          if (customTheme) {
            setCustomTheme(customTheme);
          }
        }
      } catch (err: any) {
        console.log('Failed get custom theme', err);
      }
    }
    getTheme(company);
  }, [dbUser, company]);

  useEffect(() => {
    const handleSyncVote = async (guest) => {
      const data = await syncVoteData(guest);
      if (data) {
        localStorage.setItem('mighty_poll_guest_sync', 'synced');
        //localStorage.removeItem('mighty_poll_guest')
        setGuest('');
      }
    };

    const syncGuest = localStorage.getItem('mighty_poll_guest_sync');
    if (dbUser && guest && !syncGuest) {
      handleSyncVote(guest);
    }
  }, [dbUser, guest]);

  useEffect(() => {
    if (dbUser && !dbUser.setupProfile) history.replace('/profile/setup');
    //if(dbUser) return
    //const run = async () => {
    //const mightyPollGuest = localStorage.getItem('mighty_poll_guest');
    //   if(!mightyPollGuest && !dbUser) {
    //     const data: any = await getGuestData((new Date().valueOf()).toString())
    //     localStorage.setItem('mighty_poll_guest', (data && JSON.parse(data)?.id) || '')
    //     setGuest((data && JSON.parse(data)?.id) || '')
    // }
    //if(mightyPollGuest) {
    //setGuest(mightyPollGuest)
    //}
    //};
    // if(!dbUser)
    //   run();
  }, [dbUser, history]);

  useEffect(() => {
    if (themeData && themeData.colors) {
      const root = document.documentElement;
      Object.keys(themeData?.colors).forEach((key) => {
        root.style.setProperty('--' + key, themeData.colors[key]);
      });
    }
  }, [themeData]);

  useEffect(() => {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification');
    } else {
      console.log('Notifications are supported');
      Notification.requestPermission();
    }

    const mightyPollGuest = localStorage.getItem('mighty_poll_guest');
    if (mightyPollGuest) {
      setGuest(mightyPollGuest);
    }
  }, []);
  const topscrollTo = () => {
    const el = window.document.getElementById('app');
    const el1 = window.document.getElementById('ok');
    const el2 = window.document.getElementById('ok2');
    if (el) {
      if (el.childNodes[0]) (el.childNodes[0] as any).scrollTo(0, 0);
    }
    if (el1) {
      el1.scrollTo(0, 0);
    }
    if (el2) {
      el2.scrollTo(0, 0);
    }
  };
  const isLoading = user === null && loading;
  return (
    <MyGlobalContext.Provider
      value={{
        themeData,
        setThemeData,
        customTheme,
        setCustomTheme,
        guest,
        setGuest,
      }}
    >
      <img
        alt=""
        src={ic_scroll}
        style={{
          width: 40,
          height: 40,
          position: 'fixed',
          right: 20,
          bottom: window.screen.width > 1280 ? 20 : 100,
          borderRadius: '50%',
          zIndex: 9999999,
          cursor: 'pointer',
        }}
        onClick={() => {
          topscrollTo();
        }}
      />
      <div className="h-screen overflow-x-hidden" id="ok">
        <div className="flex flex-row mx-auto">
          <PopupModule />
          <nav>
            <div className="xl:hidden">
              <Navbar />
            </div>
            <Switch>
              {routes
                .filter(
                  (route) => !route.public || route.hideBottomBar === true
                )
                .map((route, index) => (
                  <Route key={index} path={route.path} exact={route.exact}>
                    <div className="xl:hidden">
                      {dbUser && <BottomAppBar items={BOTTOM_APPBAR_ITEMS} />}
                    </div>
                    <div className="sticky top-0 hidden h-full min-h-screen xl:flex">
                      {dbUser && <WebNavbar />}
                    </div>
                  </Route>
                ))}
            </Switch>
          </nav>
          <div className="flex flex-1">
            <div className="flex-1">
              <main id="app">
                <ScrollToTop />
                <Transition
                  show={isLoading || !loaded}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform opacity-0"
                  enterTo="transform opacity-100"
                  leave="transition delay-1000 duration-500 ease-out"
                  leaveFrom="transform opacity-100"
                  leaveTo="transform opacity-0"
                  className="fixed z-20 flex items-center justify-center w-screen h-screen overflow-hidden bg-white"
                >
                  <h1>Loading</h1>
                </Transition>
                <Switch>
                  <Route exact path="/">
                    <BlankPage />
                  </Route>

                  <PrivateRoute path={`/poll/create`}>
                    <PollCreatePage />
                  </PrivateRoute>
                  <PrivateRoute path={`/poll/:duplicateId/create`}>
                    <PollCreatePage />
                  </PrivateRoute>
                  <PrivateRoute path={`/poll/pledge`}>
                    <PollCreatePage isPledge={true} />
                  </PrivateRoute>
                  <Route exact path={`/poll/:pollId`}>
                    <PollDetailPage />
                  </Route>

                  {routes.map((route, index) => {
                    const R =
                      route.public || route.enableGuest ? Route : PrivateRoute;
                    return (
                      <R
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        admin={route.admin}
                      >
                        <route.main />
                      </R>
                    );
                  })}
                </Switch>
              </main>
            </div>
          </div>
        </div>
      </div>
    </MyGlobalContext.Provider>
  );
};

export default App;
